module.exports = __webpack_public_path__ + "static/media/intro-1.4456e22b.png";